export default function getLatexEquation(input: string) {
  let latexDict = new Map<string, string>([
    ["\\kor", "\\sqrt"],
    ["\\raz", "\\frac"],
    ["\\draz", "\\dfrac"],
    ["%", "\\%"],
    [" od", " \\text{ od }"],
    [" in", " \\text{ in }"],
    ["\\nej", "\\neq"],
  ]);

  let latexDict2 = new Map<string, string>([
    // ["{","\\{"],
    //["}","\\}"],
    ["\n", "\\newline"],
    ["\\el", "\\in"],
    ["\\nel", "\\notin"],
    ["\\uni", "\\cup"],
    ["\\pre", "\\cap"],
    ["\\pods", "\\subset"],
    ["\\besk", "\\infty"],
    ["\\konj", "\\wedge"],
    ["\\disj", "\\vee"],
    ["\\kontra", "\\perp"],
    ["\\paralel", "\\parallel"],
    ["\\impl", "\\rightarrow"],
    ["\\trokut", "\\triangle"],
    ["\\kut", "\\measuredangle"],
    ["\\sklad", "\\cong"],
    ["\\crta", "\\overline"],
    ["\\ekv", "\\equiv"],
    ["\\vek", "\\overrightarrow"],
  ]);

   let greekAlphabet = new Map<string, string>([
["\\alfa", "\\alpha"],
["\\beta", "\\beta"],
["\\gama", "\\gamma"],
["\\delta", "\\delta"],
["\\epsilon", "\\epsilon"],
["\\zeta", "\\zeta"],
["\\eta", "\\eta"],
["\\theta", "\\theta"],
["\\jota", "\\iota"],
["\\kapa", "\\kappa"],
["\\lambda", "\\lambda"],
["\\mi", "\\mu"],
["\\ni", "\\nu"],
["\\ksi", "\\xi"],
["\\omikron", "o"],
["\\pi", "\\pi"],
["\\ro", "\\rho"],
["\\sigma", "\\sigma"],
["\\tau", "\\tau"],
["\\ipsilon", "\\upsilon"],
["\\fi", "\\phi"],
["\\hi", "\\chi"],
["\\psi", "\\psi"],
["\\omega", "\\omega"],
["\\Alfa", "\\Alpha"],
["\\Beta", "\\Beta"],
["\\Gama", "\\Gamma"],
["\\Delta", "\\Delta"],
["\\Epsilon", "\\Epsilon"],
["\\Zeta", "\\Zeta"],
["\\Eta", "\\Eta"],
["\\Theta", "\\Theta"],
["\\Iota", "\\Jota"],
["\\Kapa", "\\Kappa"],
["\\Lambda", "\\Lambda"],
["\\Mi", "\\Mu"],
["\\Ni", "\\Nu"],
["\\Ksi", "\\Xi"],
["\\Omikron", "O"],
["\\Pi", "\\Pi"],
["\\Ro", "\\Rho"],
["\\Sigma", "\\Sigma"],
["\\Tau", "\\Tau"],
["\\Ipsilon", "\\Upsilon"],
["\\Fi", "\\Phi"],
["\\Hi", "\\Chi"],
["\\Psi", "\\Psi"],
["\\Omega", "\\Omega"]
  ]);

 
  let rez = input.trim();

  for (let [key, value] of latexDict2.entries()) {
    rez = rez.replaceAll(key, value);
  }

  for (let [key, value] of latexDict.entries()) {
    rez = rez.replaceAll(key, value);
  }
   for (let [key, value] of greekAlphabet.entries()) {
    rez = rez.replaceAll(key, value);
  }

  return rez;

}